<template>
  <div v-if="Featured">
    <input type="checkbox" class="form-control" v-on:click="pressed" checked/>
  </div>
  <div v-else>
    <input type="checkbox" class="form-control" v-on:click="pressed"/>
  </div>
  
</template>

<script>
import { ajaxPut} from "@/ajax";
import {apiUrl} from "@/main";
export default {
  props: ["ContentId","Featured"],
  methods: {
    pressed: function(event) {
      let data;
      let featuredComp = this;
      ajaxPut(apiUrl() +"/content/featured/" + this.ContentId,
          data,
          featuredComp.dataSuccessLoad,
          featuredComp.dataError,
          localStorage.token
      );
     
    }
  }
};

</script>

<style scoped>

</style>